module.exports = __webpack_public_path__ + "static/img/22.5fab2cec.png";